module.exports = __webpack_public_path__ + "img/fachada_direction_1_format_2.351c398a.jpg";